import axios from 'axios';
import {
	Message
} from 'element-ui';
import Router from '../router/index.js'

export function log(a) {
	console.log(a)
}
export  function GetRequest() {  
   var result={}
   var href=location.href
   var arr=href.split("?")
   if(arr.length>=2){
       var search=arr[1] //p=17767157621&c=465799&hidetoggle=1
       var arr2=search.split("&")
       arr2.forEach(function(item,index){//['p=17767157621','p=17767157621']
           var key=item.split("=")[0]
           var value=item.split("=")[1]
           result[key]=value
       })
   }else{
       result={}
   }
   return result
} 
export function getCookie(key) {
	var arr1 = document.cookie.split(';');
	for (var i = 0; i < arr1.length; i++) {
		var arr2 = arr1[i].split('=');
		if (arr2[0] == key) {
			return decodeURI(arr2[1]);
		}
	}
}
export function setCookie(key, value, t) {
	var oDate = new Date();
	oDate.setDate(oDate.getDate() + t);
	document.cookie = key + '=' + value + ';expires=' + oDate.toGMTString() + ';path=/;domain=fzzht.com';
}
export function getUserId() {
	return sessionStorage.getItem("userId")
}
export function getToken() {
	return sessionStorage.getItem("token")
}
export function myurl1() {
	return "www.baidu.com777"
}
export function myurl2() {
	return "www.baidu.com666"
}
//过滤手机号
export function filterPhoneNum(str){

	let num=str.replace(/[^0-9]/ig,"")
	let phoneStr=String(num)
//	let result=num.toString().slice(-11)
	let result=""
	if(phoneStr.search("861")==0&&phoneStr.length>=13){
		result=phoneStr.slice(2)
	}else{
		result=phoneStr
	}
	console.log(num,"-num")
	console.log(result,"-result")
	return result
	
}
//正则表达式
export const phoneReg=/^1(3|4|5|6|7|8|9)[0-9]{9}$/
export const codeReg=/^\d{6}$/
export function formRule() {
	let isPhone = (rule, value, callback) => {
		let regExp = phoneReg
		let phone=filterPhoneNum(value)
		if(regExp.test(phone) === false) {
			callback(new Error('手机号格式不正确'));
		} else {
			callback();
		}
	};
	return {
		appRealname: [{
			required: true,
			message: '请输入姓名',
			trigger: 'blur'
		}, {
			min: 0,
			max: 20,
			message: '最多20个字符',
			trigger: 'blur'
		}],		
		appCellphone: [{
				required: true,
				message: '请输入手机号',
				trigger: 'blur'
			},
			{
				validator: isPhone,
				trigger: 'blur'
			}
		],
		appCompanyName: [{
			min: 0,
			max: 100,
			message: '最多100个字符',
			trigger: 'blur'
		}],
		bz_content: [{
			min: 0,
			max: 1000,
			message: '最多1000个字符',
			trigger: 'blur'
		}],
		//综合体入驻
		mj_content: [{
			min: 0,
			max: 30,
			message: '最多30个字符',
			trigger: 'blur'
		}],
		qy_content: [{
			min: 0,
			max: 50,
			message: '最多50个字符',
			trigger: 'blur'
		}],
		kjlx_content: [{
			min: 0,
			max: 50,
			message: '最多50个字符',
			trigger: 'blur'
		}],
		zyyw_content: [{
			min: 0,
			max: 200,
			message: '最多200个字符',
			trigger: 'blur'
		}],
	
		 
		//金融支持
		jrfw_content: [{
			min: 0,
			max: 1000,
			message: '最多1000个字符',
			trigger: 'blur'
		}],
		//互联网平台
		pt_content: [{
			min: 0,
			max: 1000,
			message: '最多1000个字符',
			trigger: 'blur'
		}],
		//政策
		hy_content: [{
			min: 0,
			max: 30,
			message: '最多30个字符',
			trigger: 'blur'
		}],
		//服务
		cypzfw_content: [{
			min: 0,
			max: 1000,
			message: '最多1000个字符',
			trigger: 'blur'
		}],

	}
}



// WEBPACK FOOTER //
// ./src/assets/common.js